export const svSE = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Lassie",
  legalName: "Lassie AB",
  url: "https://www.lassie.co",
  logo: "https://www.lassie.co/images/logo-with-name.svg",
  description:
    "Sveriges ledande djurförsäkring med topprankade villkor, snabba utbetalningar, fokus på förebyggande vård och Sveriges nöjdaste djurförsäkringskunder 2024 och 2025 (Svenskt Kvalitetsindex)",
  email: "hej@lassie.se",
  telephone: "+46101839818",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Döbelnsgatan 21",
    postalCode: "111 40",
    addressLocality: "Stockholm",
    addressCountry: "SE",
  },
  sameAs: [
    "https://www.facebook.com/Lassie.Sweden",
    "https://www.instagram.com/lassie_se/",
    "https://www.youtube.com/@lassie_co",
    "https://www.linkedin.com/company/lassieco/",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Försäkringar",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Hundförsäkringar",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hundförsäkring Brons",
              description:
                "Veterinärvårdsförsäkring för hundar med högsta ersättning på 30 000 kr per försäkringsår. Täcker veterinärvårdskostnader när din hund behöver vård.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hundförsäkring Silver",
              description:
                "Veterinärvårdsförsäkring för hundar med högsta ersättning på 60 000-120 000 kr per försäkringsår. Täcker medicin, rehab, foder, avancerad diagnostik och mjölktänder.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hundförsäkring Guld",
              description:
                "Omfattande veterinärvårdsförsäkring för hundar med högsta ersättning på 160 000 kr per försäkringsår. Täcker medicin, rehab, foder, avancerad diagnostik och mjölktänder.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Kattförsäkringar",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Kattförsäkring Brons",
              description:
                "Veterinärvårdsförsäkring för katter med högsta ersättning på 30 000 kr per försäkringsår. Täcker veterinärvårdskostnader när din katt behöver vård.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Kattförsäkring Silver",
              description:
                "Veterinärvårdsförsäkring för katter med högsta ersättning på 60 000-120 000 kr per försäkringsår. Täcker medicin, rehab, foder, avancerad diagnostik och mjölktänder.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Kattförsäkring Guld",
              description:
                "Omfattande veterinärvårdsförsäkring för katter med högsta ersättning på 160 000 kr per försäkringsår. Täcker medicin, rehab, foder, avancerad diagnostik och mjölktänder.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Uppfödarförsäkring",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Uppfödarförsäkring för hundar",
              description:
                "Tilläggsförsäkring för uppfödare som innehåller valpkullsförsäkring, dolda fel-försäkring, kejsarsnitt och fertilitetsutredning. Kostar 200 kr/år.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Uppfödarförsäkring för katter",
              description:
                "Tilläggsförsäkring för uppfödare som innehåller kattkullsförsäkring, dolda fel-försäkring, kejsarsnitt och fertilitetsutredning. Kostar 100 kr/år.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
    ],
  },
};
